import { useState } from "react";
import { Navigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { useAuth } from "@/AuthContext";

export default function AuthPage() {
  const { user, login } = useAuth();
  // NOTE (iter 9): 'Create account' flow disabled from the UI only. Backend /auth/register still works.
  // To re-enable: uncomment the tab strip below and the workspace-name field, and restore setMode.
  const [mode] = useState("login");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  // const [workspace, setWorkspace] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user && user !== false) return <Navigate to="/" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const path = mode === "login" ? "/auth/login" : "/auth/register";
      const body = mode === "login" ? { email, password } : { email, password, workspace_name: "My Kitchen", currency: "INR" };
      const { data } = await api.post(path, body);
      login(data);
    } catch (err) {
      setError(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen">
      <div className="flex w-full flex-col justify-center px-8 sm:px-16 lg:w-[480px]">
        <div className="mb-10">
          <h1 className="text-2xl font-semibold tracking-tight sm:text-3xl">RecipeCost</h1>
          <p className="mt-2 text-sm text-zinc-500">Recipe cost & yield calculator for kitchens. Spreadsheet-fast, always accurate.</p>
        </div>
        {/* Iter 9 — 'Create account' tab hidden. Uncomment to re-enable public signup.
        <div className="mb-6 flex border border-zinc-200">
          <button data-testid="auth-tab-login" onClick={() => { setMode("login"); setError(""); }}
            className={`flex-1 px-4 py-2 text-sm font-medium transition-colors ${mode === "login" ? "bg-zinc-950 text-white" : "bg-white text-zinc-600 hover:bg-zinc-50"}`}>
            Sign in
          </button>
          <button data-testid="auth-tab-register" onClick={() => { setMode("register"); setError(""); }}
            className={`flex-1 px-4 py-2 text-sm font-medium transition-colors ${mode === "register" ? "bg-zinc-950 text-white" : "bg-white text-zinc-600 hover:bg-zinc-50"}`}>
            Create account
          </button>
        </div>
        */}
        <form onSubmit={submit} className="space-y-4">
          {/* Iter 9 — workspace-name field hidden (only shown in register mode, which is now disabled).
          {mode === "register" && (
            <div>
              <label className="text-xs font-semibold uppercase tracking-[0.05em] text-zinc-600">Workspace name</label>
              <input data-testid="workspace-input" value={workspace} onChange={(e) => setWorkspace(e.target.value)} placeholder="My Kitchen"
                className="mt-1 block w-full rounded-sm border border-zinc-300 px-3 py-2 text-sm focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600" />
              <p className="mt-1 text-xs text-zinc-400">Currency: ₹ INR (Indian Rupee)</p>
            </div>
          )}
          */}
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.05em] text-zinc-600">Email</label>
            <input data-testid="email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="chef@kitchen.com"
              className="mt-1 block w-full rounded-sm border border-zinc-300 px-3 py-2 text-sm focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600" />
          </div>
          <div>
            <label className="text-xs font-semibold uppercase tracking-[0.05em] text-zinc-600">Password</label>
            <input data-testid="password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="mt-1 block w-full rounded-sm border border-zinc-300 px-3 py-2 text-sm focus:border-blue-600 focus:outline-none focus:ring-1 focus:ring-blue-600" />
          </div>
          {error && <div data-testid="auth-error" className="border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-600">{error}</div>}
          <button data-testid="auth-submit-button" disabled={busy} type="submit"
            className="w-full rounded-sm bg-blue-600 px-4 py-2.5 text-sm font-medium text-white transition-colors hover:bg-blue-700 disabled:opacity-50">
            {busy ? "Please wait…" : "Sign in"}
          </button>
        </form>
      </div>
      <div className="relative hidden flex-1 lg:block">
        <img src="https://images.unsplash.com/photo-1731156679850-e73fbc21564c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxtaW5pbWFsaXN0JTIwcHJvZmVzc2lvbmFsJTIwa2l0Y2hlbiUyMHByZXBhcmF0aW9ufGVufDB8fHx8MTc4MzM3Njg0OHww&ixlib=rb-4.1.0&q=85"
          alt="Professional kitchen" className="absolute inset-0 h-full w-full object-cover" />
      </div>
    </div>
  );
}
